import { Alpine, Livewire } from '../../vendor/livewire/livewire/dist/livewire.esm';
import { registerAlpine } from './alpine';
import { listenForBroadcastNotifications } from './services/broadcast-notifications';
import { setupAnalytics } from './services/analytics';
import { setupFancybox } from './vendor/fancybox';
import { listenForValidationFailures } from './support/scroll-to-first-error';
import './vendor/lazysizes';

window.Alpine = Alpine;

setupAnalytics();
setupFancybox();
registerAlpine(Alpine);
listenForBroadcastNotifications();
listenForValidationFailures();

Livewire.start();
